import { HomepageBody } from '../homepage/Homepage'

export default function Root() {
    return (
      <>
        <HomepageBody></HomepageBody>
      </>
    );
  }